import Swal from "sweetalert2"
export default async function ShowAlert(text, icon) 

{
    
const isConfirm = await Swal.fire({text: text,icon: icon,confirmButtonColor: '#3085d6',
allowEnterKey: false, allowEscapeKey: false,
allowOutsideClick: false, confirmButtonText: 'Ok',}) 
return isConfirm}


